import React, { Fragment } from "react";
import styles from "./PageHeader.module.less";
import Message from "../../../../common/Message/Message";
import { FormattedMessage, FormattedDate } from "react-intl";
const PageHeader = ({ header, effectiveDate }) => (<div className="vr vr_x4">
		<h2 className="hdg js-pageHeader">
			<Message value={header}/>
			{effectiveDate != null && (<Fragment>
					{" "}(
					<FormattedMessage id="legal.pageHeader.effectiveDate" defaultMessage="effective {date}" values={{
    date: (<span className={styles.effectiveDate}>
									<FormattedDate value={effectiveDate} month="long" day="numeric" year="numeric"/>
								</span>)
}}/>
					)
				</Fragment>)}
		</h2>
	</div>);
export default PageHeader;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/PageHeader/PageHeader.tsx